import { LogList } from '@mtg/shared';
import { api } from '../api.ts';
import { formatDateTime } from '../format.ts';
import { useApi } from '../useApi.ts';

/** What changed, when, and whether you or Claude (a write token) did it. */
export function LogPage() {
  const { data, error } = useApi(() => api('/api/log?limit=200', LogList), []);
  if (error) return <p className="error">{error}</p>;
  if (!data) return <p className="muted">Loading…</p>;
  return (
    <div className="stack">
      <h1>Change log</h1>
      {data.entries.length === 0 ? (
        <p className="muted">No changes yet.</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>When</th>
              <th>Who</th>
              <th>What</th>
            </tr>
          </thead>
          <tbody>
            {data.entries.map((e) => (
              <tr key={e.id}>
                <td className="nowrap">{formatDateTime(e.at)}</td>
                <td>
                  {e.actorName}
                  {e.actor === 'token' && <span className="badge">token</span>}
                </td>
                <td>{e.summary}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
